<template>
  <master-default>
    <h1 @click="refresh()">{{ res.chave }}</h1>

    <sub-demo></sub-demo>
    ok22 {{ msg }}

    {{ reqinfo }}

    <v-btn @click="acaoTeste()">Chama Ação</v-btn>
  </master-default>
</template>

<script>
/* eslint-disable */

try{
  var _base = require("@/page/_base.vue").default;
}catch(err){
  var _base = require("@/framework/page/_base.vue").default;
}




export default {
  extends: _base,
  data() {
    return {
      msg: "Demo Page2",
      reqinfo: global.reqClass.filtro_client
    };
  },
  methods: {
    onInit() {
      this.params = {
        a: 11,
        b: 21,
        c: this.$route.params.p1,
        d: this.$route.query.a
      };
    },

    async onLoad() {
      console.log(await global.express.call("/action/teste/demo"));
    },

    async acaoTeste() {
      let obj = await this.callLocalAction("Acao de Teste", {
        coisa: "umacoisa"
      });
      alert(obj.resultado);
    }
  },
  components: {
    masterDefault: global.reqClass.requirecmpmix("@/masters/default"),
    "sub-demo": ()=>import(/* webpackChunkName: "subdemo123" */ "@/page/sub/demo")
  }
};
</script>

<style scoped>
h1 {
  color: red;
}
</style>
